module.exports = __webpack_public_path__ + "static/media/icon_validade.008a2fb7.svg";